__turbopack_context__.v({
  "tag": "tags-list-module-scss-module__GVSm_q__tag",
  "tag--interactive": "tags-list-module-scss-module__GVSm_q__tag--interactive",
  "tag--is-rounded": "tags-list-module-scss-module__GVSm_q__tag--is-rounded",
  "tag--not-clickable": "tags-list-module-scss-module__GVSm_q__tag--not-clickable",
  "tag--small": "tags-list-module-scss-module__GVSm_q__tag--small",
  "tag--theme-active": "tags-list-module-scss-module__GVSm_q__tag--theme-active",
  "tag--theme-emphasis": "tags-list-module-scss-module__GVSm_q__tag--theme-emphasis",
  "tag--theme-light": "tags-list-module-scss-module__GVSm_q__tag--theme-light",
  "tag__icon-container": "tags-list-module-scss-module__GVSm_q__tag__icon-container",
  "tags": "tags-list-module-scss-module__GVSm_q__tags",
  "tags--center-content": "tags-list-module-scss-module__GVSm_q__tags--center-content",
  "tags__description": "tags-list-module-scss-module__GVSm_q__tags__description",
  "tags__error-message": "tags-list-module-scss-module__GVSm_q__tags__error-message",
  "tags__label": "tags-list-module-scss-module__GVSm_q__tags__label",
  "tags__list": "tags-list-module-scss-module__GVSm_q__tags__list",
});
